import {
  TaxonomyLocation,
  TaxonomyProjectTypes,
  TaxonomyTargetAudience,
  TaxonomyTheme,
} from '../implementations';

const mappers = {
  locations: TaxonomyLocation,
  project_types: TaxonomyProjectTypes,
  target_audiences: TaxonomyTargetAudience,
  themes: TaxonomyTheme,
};

export default mappers;
